/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input, OnInit } from '@angular/core';
import { Preferences } from '@capacitor/preferences';
import { ModalController, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { StoreV2Page } from 'src/app/pages/store-v2/store-v2.page';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { PurchaseService } from 'src/app/services/purchase.service';
import { UserService } from '@shared/services/user.service';
import { UtilService } from '@shared/utils/util';

@Component({
  selector: 'app-avocado-modal',
  templateUrl: './avocado-modal.component.html',
  styleUrls: ['./avocado-modal.component.scss'],
})
export class AvocadoModalComponent  implements OnInit {

  @Input() userData: any;

  constructor(private modalCtrl: ModalController,
              private translate: TranslateService,
              public purchaseServiceProvider: PurchaseService,
              private analytics: AnalyticsService,
              public userService: UserService,
              public util: UtilService,
              public toastCtrl: ToastController

  ) {}

  ngOnInit() {}

  // Fechar modal
  dismiss() {
    this.modalCtrl.dismiss();
  }

  async AvocadoClubIndicatorDefault(props: any) {
    if (props == 'show') {
      console.log(props)
      this.dismiss();

    }
    else if (props == 'join') {
      this.analytics.registerEvent(AnalyticsService.avocado);
      this.analytics.registerEvent(AnalyticsService.avcdFromIndicatorExpl);
      const modal = this.modalCtrl.create({ component: StoreV2Page, componentProps: { me: this.userData, type: "avocado_club", from: "joinClub" }, showBackdrop: true, backdropDismiss: true });
      (await modal).present();
    } else if (props == 'enableMine') {
      Preferences.get({ key: 'LAST_LOCATION' }).then((val) => {
        val = val.value ? JSON.parse(val.value) : null;

        this.userData.showAvocadoClubIndicator = true;

        const theObs = this.userService.upsertSoul(this.userData, val, false, false, false);

        theObs.subscribe(data => {

          if (data != '{not ok}') {
            const userDataLocal = JSON.parse(data);
            Preferences.set({ key: 'USER_DATA', value: JSON.stringify(userDataLocal) }).then((_val) => {
              console.log('userdata saved to DB');
            });
          }
        },
          err => {
            this.util.showToastUnableToConnect(this.toastCtrl);
            console.log('purchase-service.completePurchaseInServer: upsert error: ' + JSON.stringify(err));
          })
      })
    }
  }

}
